import type { HTMLAttributes } from 'react';
import type { Splash, SplashType } from 'autogen/swagger/all';
import type { BreakPointsType } from 'variables';

type splashesWithImagesTypes = Extract<
    SplashType,
    'ProHairCare' | 'Derma' | 'Dba' | 'Taenk' | 'ProSkin' | 'BeautyPharmacy'
>;
export const splashesWithImagesTypesArray: Array<splashesWithImagesTypes> = [
    'ProHairCare',
    'Derma',
    'Dba',
    'Taenk',
    'ProSkin',
    'BeautyPharmacy'
];

export type SplashSizes = 'sm' | 'md' | 'xl';
export type SplashSizesObject = BreakPointsType<SplashSizes>;

export interface ISplash extends Splash, HTMLAttributes<HTMLDivElement> {
    size?: SplashSizes | SplashSizesObject;
}
export interface ISplashes {
    splashes: Splash[];
}
